import "../styles.css";

const handlerError = (e) => {
  e.target.src = "images/default.jpg";
};

const getRatingClass = (rating) => {
  if (rating >= 8) {
    return "rating-good";
  } else if (rating >= 5 && rating < 8) {
    return "rating-ok";
  } else {
    return "rating-bad";
  }
};
export default function MovieCard({ movie, iswatchlisted, toggleWatchlist }) {
  return (
    <div key={movie.id} className="movie-card">
      <img
        src={`images/${movie.image}`}
        alt={movie.title}
        onError={handlerError}
      />
      <div className="movie-card-info">
        <h3 className="movie-card-title">{movie.title}</h3>
        <div>
          <span className="movie-card-genre">{movie.genre}</span>
          <span className={`movie-card-rating ${getRatingClass(movie.rating)}`}>
            {movie.rating}
          </span>
        </div>
        <label className="switch">
          <input
            type="checkbox"
            checked={iswatchlisted}
            onChange={() => toggleWatchlist(movie.id)}
          ></input>
          <span className="slider">
            <span className="slider-label">
              {iswatchlisted ? "In Watchlist" : "Add to Watchlist"}
            </span>
          </span>
        </label>
      </div>
    </div>
  );
}
